<!--用户下拉选择器-->
<template>
    <el-select size="small" v-model="check_id" placeholder="请选择" @change="handleChange" :multiple="multiple" :clearable="clearable">
        <el-option v-for="(item, key) in products" :key="key" :label="item.name" :value="item.id">
        </el-option>
    </el-select>
</template>


<script>
    import CommonService from "~/services/common";
    import Config from "~/config/params";
    export default {
        name: "Product",
        components: {
            Config,
        },
        props: {
            product_id: '',//当前选择产品id
            multiple: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                uids: null,
                products: [],
                check_id: '',
                init_id: ''
            };
        },

        created: function () {
            this.init_id = this.product_id;
            this.check_id = this.product_id;
            this.getList();
        },
    
        methods: {
            getList(){
                //加载产品列表
                CommonService.getProducts({
                    is_deleted: 0,
                    fields: 'id,name,price,code'
                }).then(res => {
                    if (res.code == 0) {
                        this.products = res.data;
                        this.products.splice(0,0,{id:'',name:'不限'});
                        // this.products.splice(1,0,{id:18,name:'校网通(额度版)'});
                        // this.products.splice(6,0,{id:123,name:'在线组卷(额度版)'});
                        // this.products = this.products.map(i=>{
                        //     if(i.code==Config.XWT_PRODUCT_CODE){
                        //         i.name = '校网通(标准版)'
                        //     }
                        //     // else if(i.code==Config.ZUJUAN_PRODUCT_CODE){
                        //     //     i.name = '在线组卷(标准版)'
                        //     // }
                        //     return i;
                        // })
                    }
                });
            },

            //select value值变化时触发
            handleChange() {
                this.$emit("change", this.check_id);
            },

            //对输入框进行重置
            reset() {
                this.check_id = this.init_id;
                this.$emit("change", this.check_id);
            }
        },
    }


</script>


// WEBPACK FOOTER //
// src/widgets/Product.vue